import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  HostListener,
  ViewChild,
} from '@angular/core';

import { Router } from '@angular/router';

import { ModalController, Platform } from '@ionic/angular';

import { ToasterService, UtilsService } from '@commons/services';

import { CancelAsync, Student, StudentPurshasesDetails } from '@app/models';
import * as moment from 'moment-timezone';
import { ModalIframeComponent, ModalMarketingComponent } from '@app/modals';

import {
  AppInitService,
  ExamenCodeService,
  ExamenConduiteService,
  LessonsService,
  NavigationService,
  NetworkStatusService,
  PageLoaderService,
  PostalCodeService,
  StatsService,
  StudentDocumentsService,
  StudentService,
} from '@app/services';

import {
  UntypedFormBuilder,
  UntypedFormControl,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';
import { EasyDebugDecorator } from '@app/decorators/easy-debug.decorator';
import { SiteOpener } from '@app/services/site-opener.service';

@EasyDebugDecorator
@Component({
  selector: 'code-exam-reservation-page',
  templateUrl: 'code-exam-reservation.page.html',
  styleUrls: ['code-exam-reservation.page.scss'],
})
export class CodeExamReservationPage extends CancelAsync {
  @ViewChild('gMap', { static: false }) mapElement: ElementRef;
  @ViewChild('modalCategPermisChanged') modalCategPermisChanged: any;
  @ViewChild('modalNEPH') modalNEPH: any;
  @ViewChild('modalNEPHInfos') modalNEPHInfos: any;

  pageTitle =
    'Code'; /* NE SERT A RIEN MAIS OBLIGATOIRE (RELIQUAT D'UN CODE NON NETTOYER #flemme) */
  activeLink =
    'code'; /* PERMET DE METTRE EN SURBRILLANCE LA CATÉGORIE DE NAV EN QUESTION LIÉE A CETTE PAGE */

  initPageDone = false; // for shimmers
  fnInitPageLaunched = false; // for controllers

  isDesktop = window.innerWidth > 767 ? true : false;
  isCordova = false;
  isPlatformDesktop = false;

  blocHeaderTitle = `Code`;

  student: Student;
  userLifeCycle: any;

  longLoading = false;
  pageStart = Date.now();
  checkPageLoadingTimeInterval: any;

  offToastConf = {
    text: 'Tu es hors ligne : certaines actions sont indisponibles',
    bgcolor: 'var(--color-danger)',
    duration: '5000',
  };

  showModal1 = false;
  errorMsg = '';
  goBackUrl = 'code';

  studentExams = null;
  codeExamReservationCurrentStep = 1;
  codeExamReservationSteps = 8;
  codeExamReservationPercentCompletion = this.utils.getPercent(
    1,
    this.codeExamReservationSteps
  );
  examCenters: any = [];
  loadingExamCenters = false;
  loadingExamCenterSessions = false;
  selectedExamCenter = null;
  selectedSession = null;
  reservationSuccessful: any = null;
  reservationErrorType: any = null;
  tenMinInMS = 600000;
  codeExamReservationBasket = null;
  usingBasket = false;
  isCodeExamReservationProceeding = false;
  map;
  months = [
    'Janvier',
    'Février',
    'Mars',
    'Avril',
    'Mai',
    'Juin',
    'Juillet',
    'Août',
    'Septembre',
    'Octobre',
    'Novembre',
    'Décembre',
  ];
  days = [
    'Dimanche',
    'Lundi',
    'Mardi',
    'Mercredi',
    'Jeudi',
    'Vendredi',
    'Samedi',
  ];

  regexDate =
    '(^((0)[1-9]|[1-2][0-9]|(3)[0-1])(\/|-)((0)[1-9]|(1)[0-2])(\/|-)[0-9]{4}$)|(^[0-9]{4}(\/|-)((0)[1-9]|(1)[0-2])(\/|-)((0)[1-9]|[1-2][0-9]|(3)[0-1])$)';
  regexNEPHNumber = '^[0-9]{12}$';
  regexPhoneNumber = '^(0|\\+33)[6-7]([-. ]?[0-9]{2}){4}$';
  regexFirstName = /^[A-Za-zÀ-ü'\-\s]+$/;

  documents: any = [];
  fetchStudentsDocumentsByUserIdFailed = false;
  registrationCertificate = null;
  registrationCertificateForm: UntypedFormGroup;
  showRegistrationCertificateFormErrors = false;
  isRegistrationCertificateFormUploading = false;
  userPhoneForm: UntypedFormGroup;
  showUserPhoneFormErrors = false;
  isUserPhoneFormUploading = false;

  displayModalNEPH = false;
  displayModalNEPHInfos = false;
  displayModalCategPermisChanged = false;

  genderList = [
    { name: 'Homme', value: 'm' },
    { name: 'Femme', value: 'f' },
  ];
  licenseList = [
    { name: 'Permis B', value: 'Permis B' },
    { name: 'Permis B1, BE', value: 'Permis B1, BE' },
    { name: 'Permis A', value: 'Permis A' },
    { name: 'Autres : Permis C, D, E...', value: 'Autres : Permis C, D, E...' },
  ];
  formsConstructed = false;

  statsSent = false;
  showModalUpload = false;
  showModalErrorServer = false;
  IABClosedObservable;
  IframeClosedObservable;

  showModalErrorServerText = '';

  // PAYMENTS GIFTS OFFERS
  studentPurshases: StudentPurshasesDetails;
  payments = [];
  gifts = [];
  coupons = [];
  paymentsGiftsCoupons: any = [];
  offers: any = [];
  fetchOffersFailed = false;
  studentCustomOffers: any = [];
  fetchStudentCustomOffersFailed = false;
  isPackPermis = false;
  isPackCode = false;
  isPackCodePremium = false;
  isHourOnly = false;
  hasHours = false;
  paymentsDone = false;

  stepChangeSub: any;
  pageLoaderSteps = [
    'init0',
    'init1',
    'init2',
    'init3',
    'init4',
    'init5',
    'initPage',
  ];
  hasMadeInit = false;

  showAutocompletes = true;

  @HostListener('window:resize', ['$event']) onResize(event) {
    this.isDesktop = window.innerWidth > 767 ? true : false;
  }

  constructor(
    private appInitService: AppInitService,
    private pageLoaderService: PageLoaderService,
    private studentService: StudentService,
    private lessonsService: LessonsService,
    private examenConduiteService: ExamenConduiteService,
    private examenCodeService: ExamenCodeService,
    private navigationService: NavigationService,
    private networkService: NetworkStatusService,
    public toasterService: ToasterService,
    public platformService: Platform,
    public formBuilder: UntypedFormBuilder,
    public modalController: ModalController,
    private router: Router,
    private statsService: StatsService,
    private utils: UtilsService,
    public siteOpenerService: SiteOpener,
    public studentDocumentsService: StudentDocumentsService,
    public postalCodeService: PostalCodeService,
    public changeDetectorRef: ChangeDetectorRef
  ) {
    super({ cancel: false, subscription: null });

    this.checkPageLoadingTimeInterval = setInterval(() => {
      const now = Date.now();
      // 3 sec
      if (now - this.pageStart >= 3000) {
        this.longLoading = true;
        clearInterval(this.checkPageLoadingTimeInterval);
      }
    }, 200);

    if (!this.appInitService.done) {
      this.navigationService.timestamp = Date.now();
      this.navigationService.lastLink = this.router.url.substr(1);
      this.hasMadeInit = true;
    } else {
      this.hasMadeInit = false;
    }
    this.goBackUrl = this.navigationService.checkUserNavigation();

    this.isCordova = this.platformService.is('cordova');
    this.isPlatformDesktop = this.platformService.is('desktop');
    this.userLifeCycle = this.studentService.getUserLifeCycle(this.student); // if student not ready return guest

    if (this.appInitService.done) {
      this.pageLoaderSteps = ['initApp', 'initPage'];
      this.pageLoaderService.setSteps(
        this.pageLoaderSteps.indexOf('initApp') + 1,
        this.pageLoaderSteps.length
      );
    }

    this.stepChangeSub = this.appInitService.onStepChange().subscribe(state => {
      if (state?.init >= 3 && state?.stepDone && !this.fnInitPageLaunched) {
        this.fnInitPageLaunched = true;
        this.initPage();
      }
      if (state?.init && state?.stepDone) {
        this.pageLoaderService.setSteps(
          state.init + 1,
          this.pageLoaderSteps.length
        );
      }
      if (state?.initDone) {
        this.initPage();
      }
    });

    this.IframeClosedObservable =
      this.navigationService.closedIframeObs$.subscribe(async event => {
        if (!!event && event.close) {
          this.student = await this.studentService.onInit();

          if (
            !this.student?.creditStocks?.codeExam?.quantity ||
            this.student?.creditStocks?.codeExam?.quantity === 0
          ) {
            return;
          }
          if (this.student?.creditStocks?.codeExam?.quantity > 0) {
            this.createCodeExamReservation();
          }
        }
      });

    this.IABClosedObservable = this.siteOpenerService.return$.subscribe(
      async event => {
        if (!!event && event.close) {
          this.student = await this.studentService.onInit();

          if (
            !this.student?.creditStocks?.codeExam?.quantity ||
            this.student?.creditStocks?.codeExam?.quantity === 0
          ) {
            return;
          }
          if (this.student?.creditStocks?.codeExam?.quantity > 0) {
            this.createCodeExamReservation();
          }
        }
      }
    );
  }

  ionViewWillLeave() {
    // this.cancel = true;
    if (!!this.subscription) {
      this.subscription.unsubscribe();
    }
    if (!!this.stepChangeSub) {
      this.stepChangeSub.unsubscribe();
    }
    if (!!this.IABClosedObservable) {
      this.IABClosedObservable.unsubscribe();
    }
    if (!!this.IframeClosedObservable) {
      this.IframeClosedObservable.unsubscribe();
    }
  }

  dateToFormatFr(input?: any) {
    // console.log('-------------------');
    // console.log('dateToFormatFr input', input, typeof input);
    let output = this.dateToMoment(); // today by default
    if (!!input) {
      output = this.dateToMoment(input);
      if (typeof input === 'string') {
        output = this.dateToMoment(input);
        // if (!input.includes('+')) {
        //   console.log('input string', input);
        // }
        if (input.includes('/')) {
          console.error('input string', input);
        }
        // console.log('output', output);
        // console.log('-------------------');
      } else if (typeof input === 'number') {
        // timestamp
        output = this.dateToMoment(input);
        // console.log('input timestamp', input);
        // console.log('output', output);
        // console.log('-------------------');
      } else if (typeof input === 'object') {
        if (
          !moment.isMoment(input) &&
          !!input.year &&
          !!input.month &&
          !!input.day
        ) {
          // custom object
          const year = input.year;
          const month =
            Number(input.month) < 10
              ? '0' + Number(input.month)
              : Number(input.month);
          const day = input.day < 10 ? '0' + input.day : input.day;
          const str = year + '-' + month + '-' + day + ' 00:00:00';
          output = this.dateToMoment(str);
          // console.log('input custom object', input, str);
          // console.log('output', output);
          // console.log('-------------------');
        } else {
          // date object
          output = this.dateToMoment(input);
          // console.log('input date', input, input.isValid());
          // console.log('output', output);
        }
      }
    }
    if (!output.isValid()) {
      console.log('-------------------');
      console.error('dateToFormatFr input', input, typeof input);
      console.error(
        'dateToFormatFr output',
        output,
        output.toString(),
        output.isValid()
      );
      console.error('-------------------');
    }
    // console.log('dateToFormatFr output', output, output.toString(), output.isValid());
    // console.log('-------------------');
    return output;
  }

  dateToMoment(input?: any) {
    const zone = 'Europe/Paris';
    moment.tz.setDefault(zone);
    moment.locale('fr');
    if (!!input) {
      return moment(input).tz(zone);
    }
    return moment().tz(zone);
  }

  async initPage() {
    this.student = await this.studentService.onInit();
    // console.log('this.student', this.student);

    this.userLifeCycle = this.studentService.getUserLifeCycle(this.student);
    if (this.userLifeCycle.isUserGuest) {
      this.openLink('code');
      return;
    }

    this.studentExams = this.examenCodeService.examens;
    // console.log('this.studentExams', this.studentExams);
    for (const exam of this.studentExams) {
      if (exam.type === 'code_exam') {
        // DATE TO CHANGE
        const dateExam = this.dateToFormatFr(exam.date);
        // DATE TO CHANGE
        if (
          dateExam >= this.dateToFormatFr() &&
          (exam.result === null || typeof exam.result === 'undefined') &&
          (exam.cancelled_at === null ||
            typeof exam.cancelled_at === 'undefined')
        ) {
          this.openLink('code');
          return;
        }
      }
    }

    const resFetchStudentsDocumentsByUserId: any =
      await this.studentDocumentsService
        .fetchStudentsDocumentsByUserId(this.student)
        .toPromise();
    if (
      !!resFetchStudentsDocumentsByUserId &&
      !!resFetchStudentsDocumentsByUserId.errorCode &&
      resFetchStudentsDocumentsByUserId.errorCode === 'E301'
    ) {
      this.documents = [];
      this.fetchStudentsDocumentsByUserIdFailed = true;
    } else {
      this.documents = resFetchStudentsDocumentsByUserId;
    }
    this.registrationCertificate = this.documents.find(
      elt =>
        elt.type ===
        this.studentDocumentsService.documentTypeRegistrationCertificate
    );
    // console.log('registrationCertificate', this.registrationCertificate);

    if (!this.isCordova) {
      this.codeExamReservationBasket =
        await this.examenCodeService.getCodeExamReservationBasketStorage(
          this.student.remoteId
        );
      // console.log('codeExamReservationBasket', this.codeExamReservationBasket);
      if (!!this.codeExamReservationBasket) {
        const tempSelectedExamCenter =
          this.codeExamReservationBasket.selectedExamCenter;
        const tempSelectedSession =
          this.codeExamReservationBasket.selectedSession;
        // console.log('tempSelectedExamCenter basket', tempSelectedExamCenter);
        // console.log('tempSelectedSession basket', tempSelectedSession);
        this.usingBasket =
          Date.now() - this.codeExamReservationBasket.timestamp <
            this.tenMinInMS && this.goBackUrl === null
            ? true
            : false;
        // console.log('this.usingBasket', this.usingBasket);
        // console.log('timer', (Date.now() - this.codeExamReservationBasket.timestamp) < this.tenMinInMS);
        // console.log('this.goBackUrl', this.goBackUrl);
        await this.examenCodeService.deleteCodeExamReservationBasketStorage(
          this.student.remoteId
        );
        if (this.usingBasket) {
          this.selectedExamCenter = tempSelectedExamCenter;
          this.selectedSession = tempSelectedSession;
          this.codeExamReservationCurrentStep = 7;
          this.codeExamReservationPercentCompletion = this.utils.getPercent(
            this.codeExamReservationCurrentStep,
            this.codeExamReservationSteps
          );
          this.codeExamReservationPercentCompletion =
            this.codeExamReservationPercentCompletion > 100
              ? 100
              : this.codeExamReservationPercentCompletion;
          if (this.student?.creditStocks?.codeExam?.quantity > 0) {
            this.createCodeExamReservation();
          }
        }
      }
    }

    this.constructForms();
    this.initPageDone = true;

    // this.codeExamReservationCurrentStep = 5; // debug
    // this.reservationErrorType = 'poste_unavailable'; // debug

    if (
      this.codeExamReservationCurrentStep === 5 &&
      !!this.registrationCertificate
    ) {
      // DATE TO CHANGE
      const isOldEnough = this.meetsMinimumAge(
        new Date(this.registrationCertificate.dob),
        16
      );
      if (isOldEnough) {
        this.changeStep('next');
      }
    }

    if (this.codeExamReservationCurrentStep === 6) {
      this.changeStep('next');
    }

    this.getPayments();

    // PAGE LOAD EVENT
    this.pageLoaderService.setSteps(
      this.pageLoaderSteps.indexOf('initPage') + 1,
      this.pageLoaderSteps.length
    );
    setTimeout(() => {
      this.pageLoaderService.stepsDone();
    }, 300);

    if (
      !!this.navigationService.timestamp &&
      !!this.navigationService.lastLink &&
      !this.statsSent
    ) {
      const statObj = {
        page: this.navigationService.lastLink,
        loadTime: Date.now() - this.navigationService.timestamp,
        withInit: this.hasMadeInit,
      };
      if (this.statsService.isDebug) {
        console.log(statObj);
      }
      this.statsService.send({ name: 'page:view', payload: statObj });
      this.statsSent = true;
    }
  }

  constructForms() {
    this.constructRegistrationCertificateForm();
    this.constructUserPhoneForm();

    this.formsConstructed = true;

    this.onChanges();
  }

  get getRegistrationCertificateForm() {
    return this.registrationCertificateForm.controls;
  }

  constructRegistrationCertificateForm() {
    this.registrationCertificateForm = this.formBuilder.group({
      firstName: new UntypedFormControl(
        '',
        Validators.compose([
          Validators.required,
          Validators.pattern(this.regexFirstName),
        ])
      ),
      lastName: new UntypedFormControl(
        '',
        Validators.compose([
          Validators.required,
          Validators.pattern(this.regexFirstName),
        ])
      ),
      gender: new UntypedFormControl(
        '',
        Validators.compose([Validators.required])
      ),
      birthdate: new UntypedFormControl(
        '',
        Validators.compose([
          Validators.required,
          Validators.pattern(this.regexDate),
        ])
      ),
      NEPHNumber: new UntypedFormControl(
        '',
        Validators.compose([
          Validators.required,
          Validators.pattern(this.regexNEPHNumber),
        ])
      ),
      license: new UntypedFormControl(
        '',
        Validators.compose([Validators.required])
      ),
    });
  }

  submitRegistrationCertificateForm(values) {
    if (this.isRegistrationCertificateFormUploading) {
      return;
    }
    if (this.networkService?.isOffline()) {
      this.launchToaster(this.offToastConf);
      return;
    }

    this.isRegistrationCertificateFormUploading = true;

    const data = {
      type: this.studentDocumentsService.documentTypeRegistrationCertificate,
      firstName: values.firstName,
      lastName: values.lastName,
      gender: values.gender,
      birthdate: values.birthdate,
      NEPHNumber: values.NEPHNumber,
      license: values.license,
      code_exam_success_statement: true,
    };
    this.studentDocumentsService
      .uploadDocument(data, this.student.remoteId)
      .subscribe(
        async res => {
          if (!!res && !!res.error && !!res.status) {
            // if (res.status === 406 || res.status === 422) { // error classic
            //   const textMsg = JSON.stringify(res);
            //   this.errorMsg = JSON.parse(textMsg).error.message;
            //   this.isRegistrationCertificateFormUploading = false;
            //   this.hideModalUpload();
            //   this.showModal1 = true;
            // }
            // if (res.status === 408) { // timeout
            //   this.errorMsg = `Nous n'avons pas pu enregistrer tes informations, merci de réessayer plus tard`;
            //   this.isRegistrationCertificateFormUploading = false;
            //   this.hideModalUpload();
            //   this.showModal1 = true;
            // }
            if (res.status === 408) {
              // timeout
              this.errorMsg = `Nous n'avons pas pu enregistrer tes informations, merci de réessayer plus tard`;
              this.isRegistrationCertificateFormUploading = false;
              this.hideModalUpload();
              this.showModal1 = true;
            } else {
              this.isRegistrationCertificateFormUploading = false;
              this.hideModalUpload();
              let strError = '';
              let duplicateNEPHCase = false;
              if (!!res.error.fields_in_error) {
                res.error.fields_in_error.forEach(elt => {
                  switch (elt) {
                    case 'duplicate-neph':
                      duplicateNEPHCase = true;
                      break;
                    case 'neph':
                      strError += 'numéro NEPH';
                      break;
                    case 'nom':
                      strError = strError !== '' ? strError + ' et ' : strError;
                      strError += 'ton nom';
                      break;
                    case 'prenom':
                      strError = strError !== '' ? strError + ' et ' : strError;
                      strError += 'ton prénom';
                      break;
                    case 'genre':
                      strError = strError !== '' ? strError + ' et ' : strError;
                      strError += 'ton sexe';
                      break;
                    case 'dateNaissance':
                      strError = strError !== '' ? strError + ' et ' : strError;
                      strError += 'ta date de naissance';
                      break;
                  }
                });
              }
              if (duplicateNEPHCase) {
                this.showModalErrorServerText = `duplicateNEPHCase`;
              } else if (strError !== '') {
                this.showModalErrorServerText = `Il semble y avoir une petite erreur avec ton <b>${strError}</b>.`;
              } else {
                this.showModalErrorServerText = `Il semble y avoir une petite erreur.`;
              }
              this.showModalErrorServer = true;
            }
            this.registrationCertificateForm.reset();
            this.resetAutocompletes();
          } else {
            this.launchToaster({
              text: 'Ton document a bien été importé et validé.',
              bgcolor: 'var(--color-info)',
              color: 'var(--color-font)',
            });
            this.registrationCertificateForm.reset();
            this.isRegistrationCertificateFormUploading = false;
            this.resetAutocompletes();
            this.hideModalUpload();
            this.initPage();
          }
        },
        err => {
          throw new Error(
            'StudentDocumentsPage submitRegistrationCertificateForm: ' +
              JSON.stringify(err)
          );
        }
      );
  }

  resetAutocompletes() {
    this.showAutocompletes = false;
    setTimeout(() => {
      this.showAutocompletes = true;
    }, 0);
  }

  get getUserPhoneForm() {
    return this.userPhoneForm.controls;
  }

  constructUserPhoneForm() {
    this.userPhoneForm = this.formBuilder.group({
      phoneNumber: new UntypedFormControl(
        !!this.student.phone ? this.student.phone : '',
        Validators.compose([
          Validators.required,
          Validators.pattern(this.regexPhoneNumber),
        ])
      ),
    });
  }

  submitUserPhoneForm(values) {
    if (this.isUserPhoneFormUploading) {
      return;
    }
    if (this.networkService?.isOffline()) {
      this.launchToaster(this.offToastConf);
      return;
    }

    if (this.userPhoneForm.valid) {
      if (
        this.userPhoneForm.pristine ||
        values.phoneNumber === this.student.phone
      ) {
        this.changeStep('next');
        return;
      }

      this.isUserPhoneFormUploading = true;

      let dob;
      if (!!this.student.dob) {
        dob = this.student.dob.split(/\/|-/);
      } else {
        dob = ['', '', ''];
      }
      const data = {
        fName: this.student.firstName,
        lName: this.student.lastName,
        birthday: {
          year: dob[2],
          month: dob[1],
          day: dob[0],
        },
        gender: this.student.gender,
        // email: values.email,
        phone: values.phoneNumber,
        postalCode: this.student.postalCode,
      };

      this.studentService.updateProfile(data, this.student.remoteId).subscribe(
        async res => {
          if (!!res && !!res.error && !!res.status) {
            const textMsg = JSON.stringify(res);
            const errorMsg = JSON.parse(textMsg).error.msg;
            this.launchToaster({
              text: `${errorMsg}`,
              bgcolor: 'var(--color-danger)',
              duration: '5000',
            });
            this.isUserPhoneFormUploading = false;
            if (res.err.status === 406) {
              // error classic
              this.showModal1 = true;
            }
            if (res.err.status === 408) {
              this.errorMsg = `Nous n'avons pas pu enregistrer tes informations, merci de réessayer plus tard`;
              this.showModal1 = true;
            }
          } else {
            this.studentService.updateUserProfil(data).then(async () => {
              this.userPhoneForm.markAsUntouched();
              this.userPhoneForm.markAsPristine();
              this.isUserPhoneFormUploading = false;
              this.launchToaster({
                text: 'Ton téléphone a bien été mis à jour',
                bgcolor: 'var(--color-info)',
                color: 'var(--color-font)',
              });
              this.initPage();
            });
          }
        },
        err => {
          this.isUserPhoneFormUploading = false;
          throw new Error(
            'CodeExamRerservation submitUserPhoneForm -> : updateProfile' +
              JSON.stringify(err)
          );
        }
      );
    }
  }

  onChanges(): void {
    this.registrationCertificateForm.valueChanges.subscribe(val => {
      this.showRegistrationCertificateFormErrors = false;
      this.isRegistrationCertificateFormUploading = false;
    });

    this.registrationCertificateForm.controls.license.valueChanges.subscribe(
      val => {
        if (val !== 'Permis B' && val !== null) {
          this.openModalCategPermisChanged();
        }
      }
    );

    this.userPhoneForm.valueChanges.subscribe(val => {
      // QA asked to show errors only on submit form event
      this.showUserPhoneFormErrors = false;
      this.isUserPhoneFormUploading = false;
      // console.log(this.userProfileForm.value);
    });
  }

  async changeStep(direction) {
    if (direction === 'prev') {
      if (
        this.codeExamReservationCurrentStep === 8 &&
        this.reservationSuccessful
      ) {
        this.openLink('code');
        return;
      }
      if (
        (this.codeExamReservationCurrentStep === 8 &&
          !this.reservationSuccessful) ||
        this.usingBasket
      ) {
        this.resetCodeExamReservation();
        return;
      }
      if (this.codeExamReservationCurrentStep > 1) {
        if (this.codeExamReservationCurrentStep === 6) {
          this.codeExamReservationCurrentStep--;
        }
        this.codeExamReservationCurrentStep--;
        this.codeExamReservationPercentCompletion = this.utils.getPercent(
          this.codeExamReservationCurrentStep,
          this.codeExamReservationSteps
        );
        this.codeExamReservationPercentCompletion =
          this.codeExamReservationPercentCompletion > 100
            ? 100
            : this.codeExamReservationPercentCompletion;
      } else {
        this.openLink('code');
        return;
      }
    }

    if (direction === 'next') {
      this.codeExamReservationCurrentStep++;
      this.codeExamReservationPercentCompletion = this.utils.getPercent(
        this.codeExamReservationCurrentStep,
        this.codeExamReservationSteps
      );
      this.codeExamReservationPercentCompletion =
        this.codeExamReservationPercentCompletion > 100
          ? 100
          : this.codeExamReservationPercentCompletion;
    }
    // console.log('codeExamReservationCurrentStep', this.codeExamReservationCurrentStep);

    if (this.codeExamReservationCurrentStep === 2 && direction === 'next') {
      if (this.networkService?.isOffline()) {
        this.launchToaster(this.offToastConf);
        return;
      }
      if (
        this.examCenters?.errorCode ||
        this.examCenters?.errorMessage ||
        this.examCenters?.errorOiginal
      ) {
        this.examCenters = [];
      }
      // DATE TO CHANGE
      const dateMin = this.dateToFormatFr();
      dateMin.date(dateMin.date() + 1);
      dateMin.set({ hours: 0, minutes: 0, seconds: 0, milliseconds: 0 });
      // DATE TO CHANGE
      const dateMax = this.dateToFormatFr();
      dateMax.date(dateMax.date() + 57);
      this.loadingExamCenterSessions = true;
      this.examCenters = await Promise.all(
        this.examCenters.map(async elt => {
          let sessions = await this.examenCodeService.fetchExamCentersSessions(
            this.student,
            elt.id_laposte,
            dateMin,
            dateMax
          );

          if (sessions?.errorCode) {
            return { ...elt, sessions: 'error', first_session: 'error' };
          }

          sessions = sessions[0];

          // DATE TO CHANGE
          const firstSession =
            Object.keys(sessions).length > 0
              ? this.dateToFormatFr(new Date(Object.keys(sessions)[0]))
              : null;
          let formattedFirstSession = null;

          if (!!firstSession) {
            const weekDay = this.days[firstSession.day()];
            const dateNumber =
              firstSession.date() < 10
                ? '0' + firstSession.date()
                : firstSession.date();
            const month = this.months[firstSession.month()];
            formattedFirstSession = `${weekDay} ${dateNumber} ${month}`;
          }

          return {
            ...elt,
            sessions: sessions,
            first_session: formattedFirstSession,
          };
        })
      );
      // console.log('examCenters', this.examCenters);
      this.loadingExamCenterSessions = false;
      // console.log('examCenters', this.examCenters);
    }

    if (this.codeExamReservationCurrentStep === 3) {
      this.changeDetectorRef.detectChanges();
      const styledMapType = new google.maps.StyledMapType(
        [
          {
            featureType: 'poi',
            elementType: 'labels',
            stylers: [{ visibility: 'off' }],
          },
        ],
        { name: 'Styled Map' }
      );

      this.map = new google.maps.Map(this.mapElement.nativeElement, {
        center: {
          lat: this.selectedExamCenter.latitude,
          lng: this.selectedExamCenter.longitude,
        },
        zoom: 16,
        zoomControl: false,
        minZoom: 5,
        maxZoom: 18,
        mapTypeControl: false,
        streetViewControl: false,
        fullscreenControl: false,
        mapTypeControlOptions: {
          mapTypeIds: ['roadmap', 'styled_map'],
        },
      });
      this.map.mapTypes.set('styled_map', styledMapType);
      this.map.setMapTypeId('styled_map');

      const markerSettings: any = {};
      markerSettings.position = {
        lat: this.selectedExamCenter.latitude,
        lng: this.selectedExamCenter.longitude,
      };
      markerSettings.icon = 'assets/2022/icons/location-pin-on.svg';

      const marker: any = new google.maps.Marker(markerSettings);
      marker.setMap(this.map); // add to map
    }

    if (
      this.codeExamReservationCurrentStep === 5 &&
      !!this.registrationCertificate
    ) {
      // DATE TO CHANGE
      const isOldEnough = this.meetsMinimumAge(
        new Date(this.registrationCertificate.dob),
        16
      );
      if (isOldEnough) {
        this.changeStep('next');
      }
    }

    if (this.codeExamReservationCurrentStep === 8) {
      this.student = await this.studentService.onInit();
      this.studentExams = await this.examenCodeService
        .fetchExamenCodeByUserId(this.student.remoteId)
        .toPromise();
    }
  }

  meetsMinimumAge(birthDate: Date, minAge) {
    // DATE TO CHANGE
    var tempDate = this.dateToFormatFr(
      new Date(
        birthDate.getFullYear() + minAge,
        birthDate.getMonth(),
        birthDate.getDate()
      )
    );
    // DATE TO CHANGE
    return tempDate <= this.dateToFormatFr();
  }

  resetCodeExamReservation() {
    this.codeExamReservationCurrentStep = 1;
    this.codeExamReservationPercentCompletion = this.utils.getPercent(
      this.codeExamReservationCurrentStep,
      this.codeExamReservationSteps
    );
    this.codeExamReservationPercentCompletion =
      this.codeExamReservationPercentCompletion > 100
        ? 100
        : this.codeExamReservationPercentCompletion;
    this.examCenters = [];
    this.selectedExamCenter = null;
    this.selectedSession = null;
    this.reservationSuccessful = null;
    this.codeExamReservationBasket = null;
    this.usingBasket = false;
  }

  resetCodeExamReservationAndRedirect(link: string) {
    this.resetCodeExamReservation();
    this.openLink(link);
  }

  async selectPostalCode(dpt_id) {
    if (this.networkService?.isOffline()) {
      this.launchToaster(this.offToastConf);
      return;
    }
    if (!!dpt_id && typeof dpt_id === 'number') {
      this.loadingExamCenters = true;

      this.examCenters = await this.examenCodeService.fetchNearbyExamCenters(
        this.student,
        dpt_id
      );

      if (!!this.examCenters) {
        this.loadingExamCenters = false;
        this.changeStep('next');
      }
    }
  }

  selectExamCenter(examCenter) {
    if (
      this.loadingExamCenterSessions ||
      !examCenter.first_session ||
      examCenter.first_session === 'error'
    ) {
      return;
    }
    this.selectedExamCenter = examCenter;
    // console.log('selectedExamCenter', this.selectedExamCenter);

    this.changeStep('next');
  }

  selectSession(session) {
    // console.log('session => ', session);
    this.selectedSession = session;
    // console.log('selectedSession', this.selectedSession);

    this.changeStep('next');
  }

  async validateReservation(action) {
    if (this.networkService?.isOffline()) {
      this.launchToaster(this.offToastConf);
      return;
    }
    if (action === 'next') {
      this.createCodeExamReservation();
    }
    if (action === 'pay') {
      if (!this.isCordova) {
        await this.saveCodeExamReservationSelection();
      }
      let offerFound = null;
      if (
        !this.student?.driving_department ||
        (!!this.student?.driving_department &&
          !this.student?.driving_department?.pricing_zone_id)
      ) {
        if (
          !!this.offers &&
          this.offers.length > 0 &&
          !this.fetchOffersFailed
        ) {
          const offersFound = this.offers.filter(
            elt => elt.offer_type === 'code_exam'
          );
          const minOffer = offersFound.reduce((prev, current) =>
            prev.amount < current.amount ? prev : current
          );
          offerFound = !!minOffer?.id ? minOffer.id : offerFound;
        }
      } else {
        if (
          !!this.studentCustomOffers &&
          this.studentCustomOffers.length > 0 &&
          !this.fetchStudentCustomOffersFailed
        ) {
          const offersFound = this.studentCustomOffers.find(
            elt => elt.offer_type === 'code_exam'
          );
          offerFound = !!offersFound?.id ? offersFound.id : offerFound;
        }
      }
      // for (const offer of this.offers) {
      //   if (offer.offer_type === 'code_exam') {
      //     offerFound = offer.id;
      //   }
      // }
      let device = 'desktop';
      if (this.platformService.is('cordova')) {
        device = this.platformService.is('ios') ? 'ios' : 'android';
      }
      const deviceAndPath = `${device}:reservation-examen-code`;
      if (!!offerFound) {
        if (!this.student.isGuest()) {
          this.openLink('paiementCodeExamReservation', {
            offerId: offerFound,
            deviceAndPath: deviceAndPath,
          });
        }
      } else {
        this.launchToaster({
          text: "Un problème est survenu, l'offre n'a pas été trouvée",
          bgcolor: 'var(--color-danger)',
          duration: '5000',
        });
        this.openLink('code');
      }
    }
  }
  async saveCodeExamReservationSelection() {
    const data = {
      selectedExamCenter: this.selectedExamCenter,
      selectedSession: this.selectedSession,
      timestamp: Date.now(),
    };
    await this.examenCodeService.setCodeExamReservationBasketStorage(
      this.student.remoteId,
      data
    );
  }

  createCodeExamReservation() {
    if (this.isCodeExamReservationProceeding) {
      return;
    }

    if (this.networkService?.isOffline()) {
      this.launchToaster(this.offToastConf);
      return;
    }
    this.isCodeExamReservationProceeding = true;
    this.examenCodeService
      .createCodeExamReservation(this.student, this.selectedSession.id)
      .subscribe(
        async res => {
          // console.log('res', res);
          if (!!res && !!res.error && !!res.status) {
            if (!!res.error.msg) {
              if (
                res.error.msg.includes('Le service est indisponible') ||
                res.error.msg.includes(
                  'Le service est momentanément indisponible'
                )
              ) {
                this.reservationErrorType = 'poste_unavailable';
              }
            } else if (
              !!res.error.fields_in_error &&
              res.error.fields_in_error.length > 0
            ) {
              res.error.fields_in_error.forEach(elt => {
                switch (elt) {
                  case 'neph':
                    this.reservationErrorType = 'neph_error';
                    break;
                  case 'nom':
                  case 'prenom':
                  case 'genre':
                  case 'dateNaissance':
                    this.reservationErrorType = 'neph_form_error';
                    break;
                }
              });
            } else {
              const textMsg = JSON.stringify(res);
              const errorMsg = JSON.parse(textMsg).error.msg;
              this.launchToaster({
                text: `${errorMsg}`,
                bgcolor: 'var(--color-danger)',
                duration: '5000',
              });
            }
            this.reservationSuccessful = false;
            this.isCodeExamReservationProceeding = false;
          } else {
            this.reservationSuccessful = true;
            this.isCodeExamReservationProceeding = false;
            this.statsService.send({ name: 'user:code_exam_booked' });
          }

          if (!this.isCordova) {
            this.codeExamReservationCurrentStep = 8;
            this.codeExamReservationPercentCompletion = this.utils.getPercent(
              this.codeExamReservationCurrentStep,
              this.codeExamReservationSteps
            );
            this.codeExamReservationPercentCompletion =
              this.codeExamReservationPercentCompletion > 100
                ? 100
                : this.codeExamReservationPercentCompletion;
            this.student = await this.studentService.onInit();
            this.studentExams = await this.examenCodeService
              .fetchExamenCodeByUserId(this.student.remoteId)
              .toPromise();
          }
          if (this.isCordova) {
            this.changeStep('next');
          }
        },
        err => {
          throw new Error(
            'CodeExamRerservation createCodeExamReservation: ' +
              JSON.stringify(err)
          );
        }
      );
  }

  getAutocompleteSelectValue(form, field, value) {
    form.controls[field].patchValue(value);
  }

  getPayments() {
    this.studentPurshases = this.studentService.getStudentPurshases();

    const resGetOffers = this.studentPurshases.offers;
    if (
      !!resGetOffers &&
      !!resGetOffers.errorCode &&
      resGetOffers.errorCode === 'E301'
    ) {
      this.fetchOffersFailed = true;
    } else {
      this.offers = resGetOffers;
    }

    const resGetStudentCustomOffers = this.studentPurshases.studentCustomOffers;
    if (
      !!resGetStudentCustomOffers &&
      !!resGetStudentCustomOffers.errorCode &&
      resGetStudentCustomOffers.errorCode === 'E301'
    ) {
      this.fetchStudentCustomOffersFailed = true;
    } else {
      this.studentCustomOffers = resGetStudentCustomOffers;
    }
    this.gifts = this.studentPurshases.gifts;
    this.studentPurshases.linkOfferTopayment();
    this.studentPurshases.removeCouponsIfPresentInPayments();
    this.payments = this.studentPurshases.payments;
    this.coupons = this.studentPurshases.coupons;

    this.hasHours = this.studentPurshases.hasHours();
    this.isHourOnly = this.studentPurshases.isHourOnly();
    this.isPackCode = this.studentPurshases.isPackCode();
    this.isPackCodePremium = this.studentPurshases.isPackCodePremium();
    this.isPackPermis = this.studentPurshases.isPackPermis();

    const tmp = this.gifts.concat(this.coupons);
    this.paymentsGiftsCoupons = tmp.concat(this.payments);

    this.paymentsDone = true;
  }

  launchToaster(config) {
    this.toasterService.create(config);
  }

  hideModal1() {
    this.showModal1 = false;
  }

  hideModalUpload() {
    this.showModalUpload = false;
  }

  hideModalErrorServer() {
    this.showModalErrorServer = false;
  }

  callHideModalCategPermisChanged(action?) {
    this.modalCategPermisChanged.closeModal();
  }

  hideModalCategPermisChanged() {
    this.displayModalCategPermisChanged = false;
  }

  openModalCategPermisChanged() {
    this.displayModalCategPermisChanged = true;
  }

  callHideModalNEPH(action?) {
    this.modalNEPH.closeModal();
  }

  hideModalNEPH() {
    this.displayModalNEPH = false;
  }

  openModalNEPH() {
    this.displayModalNEPH = true;
  }

  callHideModalNEPHInfos(action?) {
    this.modalNEPHInfos.closeModal();
  }

  hideModalNEPHInfos() {
    this.displayModalNEPHInfos = false;
  }

  openModalNEPHInfos() {
    this.displayModalNEPHInfos = true;
  }

  async openModalPack(
    bannerInfo?: any,
    type?: string,
    noClose = false,
    customClass = ''
  ) {
    // evs-global.scss : small-modal | medium-modal
    if (!type) {
      type = 'marketingRegular';
    }
    let props;
    if (!!bannerInfo) {
      props = {
        type: type,
        bannerInfo: {
          item_id: bannerInfo.itemId,
          item_promo_type: bannerInfo.itemPromoType,
          item_location_id: bannerInfo.itemLocationId,
          item_location_format: bannerInfo.itemLocationFormat,
          item_promo_content: bannerInfo.itemPromoContent,
        },
      };
    } else {
      props = {
        type: type,
        bannerInfo: null,
      };
    }
    let modal;
    if (noClose) {
      modal = await this.modalController.create({
        component: ModalMarketingComponent,
        backdropDismiss: false,
        cssClass: customClass,
        componentProps: props,
      });
    } else {
      modal = await this.modalController.create({
        component: ModalMarketingComponent,
        cssClass: customClass,
        componentProps: props,
      });
    }
    return await modal.present();
  }

  async openModalIframe(url: any, type?: string, noClose = true) {
    if (!type) {
      type = 'iframe';
    }
    let modal;
    if (noClose) {
      modal = await this.modalController.create({
        component: ModalIframeComponent,
        backdropDismiss: false,
        cssClass: 'custom-modal-iframe',
        componentProps: {
          type: type,
          url: url,
        },
      });
    } else {
      modal = await this.modalController.create({
        component: ModalIframeComponent,
        cssClass: 'custom-modal-iframe',
        componentProps: {
          type: type,
          url: url,
        },
      });
    }
    return await modal.present();
  }

  async openLink(link, options: any = {}) {
    const callbackUrl = await this.navigationService.open(link, options);
    if (!!callbackUrl && callbackUrl !== '') {
      this.openModalIframe(callbackUrl);
    }
  }
}
